(function(angular){
    'use strict';
    class ActionBarComponent {
        constructor($mdMenu, $rootScope, ContactManagerNavigationService) {
            this.$mdMenu = $mdMenu;
            this.ContactManagerNavigationService = ContactManagerNavigationService;

            $rootScope.$on('$locationChangeStart', ()=>{
                $mdMenu.hide();
            });
        }

        actionClicked(ev, action){
            this.$mdMenu.hide();

            // well. we hit an action that was not a link to another page (see comment below)
            // since we did not reload the page, this code removes all our actions, and they dont get reloaded
            if(!action.doNotDisableActions) {
                // this will fix actions bleeding between pages,
                // but if the action is not a link to another page
                // then this will need to be changed
                for (let i = 0; i < this.actions.length; i++) {
                    this.actions[i].enabled = false;
                }
            }

            if(action.onClick) {
                action.onClick();
            }
        }

        buttonClicked(action) {
            if(!action.doNotDisableActions) {
                // this will fix actions bleeding between pages,
                // but if the action is not a link to another page
                // then this will need to be changed
                for (let i = 0; i < this.actions.length; i++) {
                    this.actions[i].enabled = false;
                }
            }

            if(action.onClick) {
                action.onClick();
            }
        }

        goBack() {
            this.ContactManagerNavigationService.smartBackAction();
        }
    }

    angular.module('MW.Influencers.ActionBarComponent', [
        'ngMaterial',
        'mwAppComponents',
        'MW.ContactManager.ContactManagerNavigationService'
    ])
    .component('actionBarComponent', {
        bindings: {
            actions: '<',
            pageTitle: '<',
            isVisible: '<',
            isBackButtonVisible: '<'
        },
        controller: ['$mdMenu', '$rootScope', 'ContactManagerNavigationService', ActionBarComponent],
        template: `
        <div layout="column" layout-fill ng-if="$ctrl.isVisible">
            <mw-toolbar>
                <mw-icon-button ng-if="$ctrl.isBackButtonVisible" ng-click="$ctrl.goBack()" svg-icon="navigation:ic_arrow_back_24px" hover="true"></mw-icon-button>
                <mw-toolbar-separator ng-if="$ctrl.isBackButtonVisible"></mw-toolbar-separator>
                <mw-toolbar-title flex class="md-truncate" ng-if="$ctrl.pageTitle">
                    {{$ctrl.pageTitle}}
                </mw-toolbar-title>
                <div flex></div>
                <md-menu class="mw-menu" md-position-mode="target-left target" md-offset="0 50" ng-if="$ctrl.actions.length > 1">
                    <mw-menu-trigger-button class="mw-menu-trigger-button--accent" tooltip="{{'Open Menu' | translate}}" on-click="$mdMenu.open($event)" icon-size="normal">
                        {{'ACTIONS' | translate}}
                    </mw-menu-trigger-button>
                    <md-menu-content class="mw-menu-dropdown" md-padding="md-padding">
                        <div ng-repeat="action in $ctrl.actions" ng-if="action.tutorialId" data-tutorial-id="{{::action.tutorialId}}" title="{{::action.label}}">
                            <mw-menu-item ng-if="action.enabled" icon="{{::action.icon}}" aria-label="{{::action.label}}" on-click="$ctrl.actionClicked($event, action)">{{::action.label}}</mw-menu-item>
                        </div>
                        <div ng-repeat="action in $ctrl.actions" ng-if="!action.tutorialId" title="{{::action.label}}">
                            <mw-menu-item ng-if="action.enabled" icon="{{::action.icon}}" aria-label="{{::action.label}}" on-click="$ctrl.actionClicked($event, action)">{{::action.label}}</mw-menu-item>
                        </div>
                    </md-menu-content>
                </md-menu>
                <md-button ng-if="$ctrl.actions.length === 1 && !$ctrl.actions[0].optInToggle" class="mw-button mw-button--accent md-primary md-raised md-accent action-bar-button" aria-label="{{::$ctrl.actions[0].label}}" ng-click="$ctrl.buttonClicked($ctrl.actions[0])" disabled="disabled" data-tutorial-id="{{$ctrl.actions[0].tutorialId}}">{{::$ctrl.actions[0].label}}</md-button>
                <md-button ng-if="$ctrl.actions.length === 1 && $ctrl.actions[0].optInToggle" class="opt-in-out-button mw-button" aria-label="{{::$ctrl.actions[0].label}}" ng-click="$ctrl.actions[0].onClick($event)" data-tutorial-id="{{$ctrl.actions[0].tutorialId}}">{{::$ctrl.actions[0].label}}</md-button>
            </mw-toolbar>
        </div>
        `
    });
})(window.angular);